(() => {
  const desktop = document.querySelector('.desktop-nav[data-film-navigation]');
  const mobile = document.getElementById('MenuPanel');
  const wide = matchMedia('(min-width: 1251px)');
  const hover = matchMedia('(hover: hover) and (pointer: fine)');
  const items = [...document.querySelectorAll('[data-film-nav-item]')];
  let closeTimer;
  let hoverOpened = null;
  const summary = item => item.querySelector(':scope > summary');
  const setOpen = (item, open) => {
    item.open = open;
    summary(item).setAttribute('aria-expanded', String(open));
  };
  const closeDesktop = () => {
    clearTimeout(closeTimer);
    items.filter(item => item.dataset.navMode === 'desktop').forEach(item => setOpen(item, false));
    hoverOpened = null;
  };
  const openItem = item => {
    clearTimeout(closeTimer);
    items.filter(other => other !== item && other.dataset.navMode === item.dataset.navMode).forEach(other => setOpen(other, false));
    setOpen(item, true);
  };
  items.forEach(item => {
    const trigger = summary(item);
    trigger.addEventListener('click', event => {
      event.preventDefault();
      if (hoverOpened === item) { hoverOpened = null; return; }
      if (item.open) setOpen(item, false); else openItem(item);
    });
    item.addEventListener('toggle', () => trigger.setAttribute('aria-expanded', String(item.open)));
    if (item.dataset.navMode !== 'desktop') return;
    item.addEventListener('pointerenter', event => {
      if (!wide.matches || !hover.matches || event.pointerType !== 'mouse') return;
      const wasOpen = item.open;
      openItem(item);
      if (!wasOpen) hoverOpened = item;
    });
    item.addEventListener('pointerleave', () => {
      closeTimer = setTimeout(() => { if (!item.contains(document.activeElement)) closeDesktop(); }, 180);
    });
    trigger.addEventListener('keydown', event => {
      if (event.key !== 'ArrowDown') return;
      event.preventDefault(); hoverOpened = null; openItem(item);
      item.querySelector('[data-film-mega] a')?.focus();
    });
  });
  desktop?.addEventListener('focusout', () => {
    setTimeout(() => { if (!desktop.contains(document.activeElement)) closeDesktop(); }, 0);
  });
  desktop?.querySelectorAll('.film-nav-direct').forEach(link => link.addEventListener('pointerenter', closeDesktop));
  document.addEventListener('click', event => {
    if (!desktop?.contains(event.target)) closeDesktop();
    if (event.target.closest('[data-open]')) closeDesktop();
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const open = items.find(item => item.open && item.dataset.navMode === 'desktop');
    if (open) { closeDesktop(); summary(open).focus(); }
  });
  mobile?.addEventListener('close', () => {
    items.filter(item => item.dataset.navMode === 'mobile').forEach(item => setOpen(item, false));
    mobile.querySelectorAll('[data-film-nav-group]').forEach(group => { group.open = false; });
    const trigger = document.querySelector('[data-open="MenuPanel"]');
    trigger?.setAttribute('aria-expanded', 'false');
    trigger?.focus();
  });
  wide.addEventListener('change', () => {
    closeDesktop();
    if (wide.matches && mobile?.open) mobile.close();
  });
})();
